export const EMAIL_EXP = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
export const PASSWORD_EXP = /^(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{10,12}$/;
